import React from 'react'
import {Icon} from '@components/common/base/icon'

export type SortState = 'default' | 'up' | 'down'

interface SortProps {
  state: SortState
}

export const Sort = (props: SortProps) => {
  const getIconName = () => {
    if (props.state === 'down') {
      return 'IconCustomSortDown'
    }
    if (props.state === 'up') {
      return 'IconCustomSortUp'
    }
    return 'IconCustomSortDefault'
  }

  return <Icon icon={getIconName()} color="placeholder" />
}
